import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

interface FolderIconWrapperProps {
  isFolder: boolean
}

export const FolderIconWrapper = styled.span<FolderIconWrapperProps>`
  display: flex;
  ${({ isFolder }) =>
    isFolder &&
    `svg path {
      fill: ${Color.Lavender100};
    }`}
`

export const NameWrapper = styled.div`
  min-width: 0;
  overflow-wrap: anywhere;
`

export const NameCellWrapper = styled.div`
  display: flex;
  align-items: center;
`
